const deps = {};

class FaqController {
  constructor($state, $rootScope, $timeout, laboxSSapi, navigationManager, $scope, $window, analyticsService) {
    this.$timeout = $timeout;
    this.name = 'Quick Tips';
    this.$rootScope = $rootScope;
    this.$state = $state;
    deps.$state = $state;
    this.isCablevision = this.$rootScope.isCablevision;
    this.isSuddenlink = this.$rootScope.isSuddenlink;
    this.menuitemsLoader = true;

    navigationManager.registerViewComponent(this, $scope, 'home.faq');

    if (this.isCablevision == true) {
      laboxSSapi.getOptFaq().then((res) => {
        // omniture when faq load successfully
        console.log('!!omniture when faq load successfully!!');
        analyticsService.sendReport('quick tips', 'quick tips', 'event1', null, null, null, null, null,
          this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill);

        const faqOpt = [];
        const groups = _.groupBy(res.data.labox_faq.quick_tips, subgroup => subgroup.position_id);
        for (const key in groups) {
          faqOpt.push({
            layout: groups[key][0].summary_template,
            title: groups[key][0].title,
            footer: groups[key][0].footer_text,
            summary: groups[key][0].summary_desc,
            summary_with_image: groups[key][0].summary_desc_with_img,
            main_content: groups[key][0].main_content,
            summary_image: groups[key][0].summary_image,
            primary_image: groups[key][0].primary_image,
            sub_title: groups[key][0].sub_title
          });
          this.menuitems = faqOpt;
        }
      }, (reserr)=> {
        // omniture when faq with API error
        console.log('!!omniture when faq with API error!!');
        analyticsService.sendReport('quick tips', 'quick tips', 'event1', 'api error', null, null, null, null, this.$rootScope.omnitureBillingStatus, 
          this.$rootScope.omniturePaperlessbill, this.$rootScope.analytics.omniturePath +'/faq');

        console.log('fail ---> ', reserr);
        this.$rootScope.fromFaqPage = true;
        this.$state.go('home.landingpage');
      });
    } else if (this.isSuddenlink == true) {
      laboxSSapi.getSdlFaq().then((res) => {
        const faqSdl = [];
        const groups = _.groupBy(res.data.labox_faq.quick_tips, subgroup => subgroup.position_id);
        for (const key in groups) {
          faqSdl.push({
            layout: groups[key][0].summary_template,
            title: groups[key][0].title,
            footer: groups[key][0].footer_text,
            summary: groups[key][0].summary_desc,
            summary_with_image: groups[key][0].summary_desc_with_img,
            main_content: groups[key][0].main_content,
            summary_image: groups[key][0].summary_image,
            primary_image: groups[key][0].primary_image,
            sub_title: groups[key][0].sub_title
          });
          this.menuitems = faqSdl;
        }
      }, (reserr)=> {
        console.log('fail ---> ', reserr);
        this.$rootScope.fromFaqPage = true;
        this.$state.go('home.landingpage');
      });
    }
  }
}

FaqController.$inject = [
  '$state',
  '$rootScope',
  '$timeout',
  'laboxSSapi',
  'navigationManager',
  '$scope',
  '$window',
  'analyticsService'
];

export default FaqController;



// WEBPACK FOOTER //
// ./client/app/components/faq/faq.controller.js